export default __webpack_public_path__ + "images/ARYSTAN.f5e7a67.png";